import { takeLatest, put, call } from "@redux-saga/core/effects";
import { getActiveAppAPI, getUnreadNotificationAPI, updateNotificationAPI } from "../../apis/pgapis";
import { fetchActivePGAppFailure, fetchActivePGAppSucc, getUnreadNotificationFailure, getUnreadNotificationSuccess, updateNotificationFailure, updateNotificationSuccess } from "./appActions";
import { FETCH_ACTIVE_PGAPPS_START, GET_UNREAD_NOTIFICATION_START, UPDATE_NOTIFICATION_START } from "./appTypes";
import { refreshApp } from "../ctrl/ctrlActions";

/** start of fetch active apps */




export function* onFetchActivePGAppsAsync(action) {
  try {
    const response = yield call(getActiveAppAPI)
    yield put(fetchActivePGAppSucc(response));
  } catch (e) {
    console.log(e);
    if (e?.response?.status === 403) { yield put(refreshApp(true)) }
    yield put(fetchActivePGAppFailure(e));
  }
}

export function* onFetchActivePGApps() {
  yield takeLatest(FETCH_ACTIVE_PGAPPS_START, onFetchActivePGAppsAsync)
}


export function* onUpdateNotificationAsync({ payload }) {
  try {
    const response = yield call(updateNotificationAPI, payload)
    if (response.status === 200) {
      yield put(updateNotificationSuccess(response));
    }
    console.log("onUpdateNotificationAsync. ", response.status);
  } catch (e) {
    console.log(e);
    yield put(updateNotificationFailure(e));
  }
}

export function* onUpdateNotification() {
  yield takeLatest(UPDATE_NOTIFICATION_START, onUpdateNotificationAsync)
}

export function* onGetUnreadNotificationAsync({ email }) {
  try {
    const response = yield call(getUnreadNotificationAPI, email)
    console.log("response in onGetUnreadNotificationAsync. ", response);
    if (response.status === 200) {
      yield put(getUnreadNotificationSuccess(response.data));
    }
    console.log("onGetUnreadNotificationAsync. ", response.status);
  } catch (e) {
    console.log(e);
    yield put(getUnreadNotificationFailure(e));
  }
}

export function* onGetUnreadNotification() {
  yield takeLatest(GET_UNREAD_NOTIFICATION_START, onGetUnreadNotificationAsync)
}


/** End of fetch active apps */